import styled from 'styled-components'
import { space } from 'styled-system'

export const ImageCount = styled('span')(
  {
    borderRadius: '50%',
    width: 40,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    zIndex: 1,
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      inset: 0,
      borderRadius: 'inherit',
      backgroundColor: '#000',
      opacity: 0.4,
      zIndex: -1
    }
  },
  space
)
